// src/admin/auth/RequireAdminAuth.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';
import { useCurrentUser } from './CurrentUserContext';
import AdminPreAuthLayout from '../layouts/AdminPreAuthLayout';
import LoadingView from '../../shared/components/LoadingView';

export default function RequireAdminAuth({ children }) {
  const {
    isAuthenticated,
    loading,
    bootstrapAttempts,
    retryBootstrapNow,
  } = useAdminAuth();
  const { user } = useCurrentUser();
  const location = useLocation();

  if (loading) {
    const subtitle =
      bootstrapAttempts > 3
        ? 'Still trying to reach the server…'
        : 'One moment while we verify your session.';
    return (
      <AdminPreAuthLayout maxWidth={480}>
        <LoadingView
          symbolClass="bi bi-shield-lock"
          title="Signing you in…"
          subtitle={subtitle}
          className="py-5"
          fullViewport
        />
        {bootstrapAttempts > 3 && (
          <div className="text-center mt-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={retryBootstrapNow}
            >
              Retry now
            </button>
          </div>
        )}
      </AdminPreAuthLayout>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login/" state={{ from: location }} replace />;
  }

  if (user?.onboarding?.needs_org_setup) {
    return <Navigate to="/admin/register?step=3" replace />;
  }

  return children;
}
